import settings from '../settings';
import 'tooltipsy';
import Post from '../ui/post';

export default class LivePosts
{
    constructor(postInstance)
    {
        this.postInstance = postInstance;
        // Sets can only contain object references!
        this.mapPosts = new Map();
        this.mapPostsFlushed = new Map();
        this.intervalMs = 10000;
        this.interval = null;
        this.$newPosts = $('#newposts');
        this.$newPostsNumber = $('#newposts_number');
        this.$newPostsPlural = $('#newposts_plural');
        this.$post = $('.post');
    }

    getLastPostTimestamp()
    {
        return this.$post.data('created');
    }

    // We just created these so just ignore them.
    ignorePost(post)
    {
        this.mapPosts.set(post.id, post);
        this.mapPostsFlushed.set(post.id, post);
    }

    ignorePosts(posts)
    {
        posts.forEach((post) => this.ignorePost(post));
    }

    poll()
    {
        // remove extraneous hashes and stuff
        let loc = window.location.origin +
                window.location.pathname +
                window.location.search,
            hasQS = loc.match(/\?/),
            attach = (hasQS)?'&':'?';

        if (loc.indexOf('posts') == -1) {
            return;
        }

        if (loc.indexOf('analytics') > -1) {
            return;
        }

        if (loc.indexOf('likes') > -1) {
            return;
        }

        if (loc.indexOf('likes-and-shares') > -1) {
            return;
        }

        let url = loc + attach + 'since=' + this.getLastPostTimestamp();

        $.ajax({
            headers   : settings.api_headers,
            url       : url,
            type      : 'GET',
            dataType  : 'json'
        })
        .always((data) => {
            if ('undefined' === typeof data.posts)
                return;
            data.posts.forEach((post) => this.mapPosts.set(post.id, post));

            let intAvailablePosts = this.mapPosts.size - this.mapPostsFlushed.size

            if (0 < intAvailablePosts)
                this.newPostsAvailable(intAvailablePosts);
        });
    }

    newPostsAvailable(number)
    {
        this.$newPostsNumber.text(number);
        this.$newPosts.removeClass('visually-hidden');
        this.$newPostsPlural.text((1 == number)?'':'s')
    }

    showNewPosts()
    {
        var map = new Map([...this.mapPosts.entries()].sort());

        const leftColCount = $('.post-list--left .post').length;
        const rightColCount = $('.post-list--right .post').length;

        let col = leftColCount > rightColCount ? 'right' : 'left';

        map.forEach((post) => {
            if (this.mapPostsFlushed.has(post.id)) {
                return;
            }

            this.mapPostsFlushed.set(post.id, post);

            Post.renderPost(0, post, this.postInstance, true, false, false, col, true);
            col = col == 'left' ? 'right' : 'left'; // Alternate the columns

            this.mapPosts.delete(post.id);
        });

        this.$newPosts.addClass('visually-hidden');
        // Could move this to renderPost but I'm not keen on it being triggered N times
        $('.tooltip').tooltipsy({ offset: [0, -10]});
    }

    startPoll()
    {
        this.interval = setInterval(
            // really keen to use ::bind
            this.poll.bind(this),
            this.intervalMs
        );
        // so keen to use ::bind
        this.$newPosts.on('click', this.showNewPosts.bind(this));
    }
};
